import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, Box, Card, Avatar } from '@material-ui/core';
import DescriptionIcon from '@material-ui/icons/Description';
import { IdeaCss } from '../IdeaCss';
import { history } from '../../../helpers';
import { useIdeaDetailsController } from '../../../containers/IdeaDetailsPage/hooks/useIdeaDetailsController';

export function IdeaDetails() {
  const classes = IdeaCss();
  const { t } = useTranslation();
  const { hasIdeaFlux } = useIdeaDetailsController();

  function goToChallenge() {
    history.push(`/challenge/detail/${hasIdeaFlux.challenge._id}`);
  }

  return (
    <Grid item xs={12}>
      <Card elevation={0} className={classes.cardSmall}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box display="flex" alignItems="center">
              <Avatar className={classes.avatarIcon}>
                <DescriptionIcon color="primary" fontSize="small" />
              </Avatar>
              <Typography variant="subtitle1">{t('detalhes')}</Typography>
            </Box>
          </Grid>
          {hasIdeaFlux?.code && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">{t('codigo')}</Typography>
              <Typography variant="body2">{hasIdeaFlux.code}</Typography>
            </Grid>
          )}
          {hasIdeaFlux.challenge?.name && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">{t('desafio')}</Typography>
              <Typography variant="body2" className={classes.challengeLink} onClick={goToChallenge}>
                {hasIdeaFlux.challenge.name}
              </Typography>
            </Grid>
          )}
          {hasIdeaFlux?.personalizedClassifications && hasIdeaFlux?.personalizedClassifications.length > 0 && (
            <Grid item xs={12}>
              <Typography variant="subtitle2">{t('classificacao')}</Typography>
              <Box display="flex" flexDirection="column" justifyContent="flex-start">
                {hasIdeaFlux?.personalizedClassifications?.map((classification, index) => (
                  <Typography variant="body2" key={index}>- {classification.name}</Typography>
                ))}
              </Box>
            </Grid>
          )}
        </Grid>
      </Card>
    </Grid>
  );
}
